import { useCallback, useState } from 'react';
import { useSpring } from '@react-spring/web';
import { useConstant } from '@pushpay/utils';
export function useScrollShadowStyle() {
  const [isScrolled, setIsScrolled] = useState(false);
  const observer = useConstant(() => new IntersectionObserver(([{
    isIntersecting
  }]) => setIsScrolled(!isIntersecting), {
    threshold: 1
  }));
  const listenerRef = useCallback(node => {
    if (node) {
      observer.observe(node);
    } else {
      observer.disconnect();
    }
  }, [observer]);
  const style = useSpring({
    from: {
      opacity: 0
    },
    to: {
      opacity: isScrolled ? 1 : 0
    }
  });
  return [style, listenerRef];
}